import { Link } from "react-router-dom";

export default function CTASection() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20abstract%20geometric%20pattern%20with%20warm%20red%20and%20amber%20light%20streaks%2C%20dynamic%20energy%20flow%2C%20mysterious%20and%20powerful%20atmosphere%2C%20minimalist%20composition%2C%20cinematic%20gradient%20with%20deep%20shadows&width=1800&height=600&seq=cta-bg-heiliao&orientation=landscape"
          alt=""
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-background-50/85"></div>
      </div>

      <div className="relative container-custom text-center">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-foreground-100 mb-4">
          你有故事，我们有平台
        </h2>
        <p className="text-foreground-400 text-base md:text-lg max-w-2xl mx-auto mb-8">
          每一个内幕都值得被看见。加入黑料社区，与数百万真相追寻者一起，让隐秘曝光于阳光之下。
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/about"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-background-950 rounded-lg font-semibold text-base transition-all duration-200 whitespace-nowrap"
          >
            <i className="ri-user-add-line mr-2 w-5 h-5 inline-flex items-center justify-center align-middle"></i>
            加入社区
          </Link>
          <Link
            to="/about#contact"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-100/80 hover:bg-background-100 text-foreground-200 rounded-lg font-medium text-base transition-all duration-200 border border-background-200/60 whitespace-nowrap"
          >
            <i className="ri-mail-send-line mr-2 w-5 h-5 inline-flex items-center justify-center align-middle"></i>
            联系我们
          </Link>
        </div>
      </div>
    </section>
  );
}